import ActionTypes from "../constants/action_types";

export default function clearSearchByIssue() {
  return {
    type: ActionTypes.SEARCH_BY_ISSUE_CLEAR.SUCCESS,
  };
}
